import styled, { css } from 'styled-components'

const DisabledStyle = css`
  pointer-events: none;
  opacity: .5;
`

export const Group = styled.div`
  display: flex;
  position: relative;
  ${({ disabled }) => disabled && DisabledStyle}
`

const SelectedStyle = css`
  color: ${({ theme }) => theme.snow};
  background-color: ${({ theme }) => theme.primary};
`

export const Btn = styled.div`
  display: flex;
  text-decoration: none;
  display: inline-block;
  padding: 1rem;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  font-size: 1.4rem;
  font-weight: 400;
  text-transform: capitalize;
  transition: all .2s;
  position: relative;
  overflow: hidden;
  line-height: 1.5;
  appearance: none;
  opacity: .85;
  border-top: 1px solid ${({ theme, selected }) => selected ? theme.primary : theme.border};
  border-bottom: 1px solid ${({ theme, selected }) => selected ? theme.primary : theme.border};
  cursor: pointer;

  &:active,
  &:focus {
    outline: none;
    opacity: 1;
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-left: 1px solid ${({ theme, selected }) => selected ? theme.primary : theme.border};
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right: 1px solid ${({ theme, selected }) => selected ? theme.primary : theme.border};
  }

  ${({ selected }) => selected && SelectedStyle}

  @media (hover: hover) {
    &:hover {
      opacity: 1;
      ${({ selected }) => !selected && css`background-color: ${({ theme }) => theme.border};`}
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/ButtonGroup/styles.js